import { render, staticRenderFns } from "./AboutIvyed3.vue?vue&type=template&id=4173c41d&"
import script from "./AboutIvyed3.vue?vue&type=script&lang=js&"
export * from "./AboutIvyed3.vue?vue&type=script&lang=js&"
import style0 from "./AboutIvyed3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VCard,VChip})
